module.exports = __webpack_public_path__ + "img/erweima.7df9b652.png";